import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "@/components/site/Reveal";
import SectionLabel from "@/components/site/SectionLabel";
import { FAQS } from "@/lib/site";

export default function FAQSection({ limit }) {
    const items = typeof limit === "number" ? FAQS.slice(0, limit) : FAQS;
    return (
        <section
            data-testid="faq-section"
            className="relative bg-[#060c1e] py-24 md:py-32"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
                    <div className="md:col-span-5">
                        <Reveal>
                            <SectionLabel testId="faq-label">
                                Common Questions
                            </SectionLabel>
                            <h2 className="mt-6 font-display font-black text-white text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                                Frequently{" "}
                                <span className="text-[#D4AF37]">asked</span>.
                            </h2>
                            <p className="mt-6 text-white/70 leading-relaxed max-w-md">
                                The questions men ask before they apply. If
                                yours isn’t here, bring it to the call.
                            </p>
                        </Reveal>
                    </div>

                    <div className="md:col-span-7">
                        <Accordion
                            type="single"
                            collapsible
                            data-testid="faq-accordion"
                            className="border-t border-[#142142]"
                        >
                            {items.map((item, i) => (
                                <AccordionItem
                                    key={i}
                                    value={`item-${i}`}
                                    data-testid={`faq-item-${i + 1}`}
                                    className="border-b border-[#142142]"
                                >
                                    <AccordionTrigger className="text-left text-white hover:text-[#D4AF37] hover:no-underline py-6 text-base md:text-lg font-display font-semibold tracking-tight">
                                        {item.q}
                                    </AccordionTrigger>
                                    <AccordionContent className="text-white/70 leading-relaxed pb-6 text-base">
                                        {item.a}
                                    </AccordionContent>
                                </AccordionItem>
                            ))}
                        </Accordion>
                    </div>
                </div>
            </div>
        </section>
    );
}
